import { useState, useRef } from 'react'

export default function useNotification(): [string | boolean, any, boolean] {
  const [notification, setnotification] = useState<string | boolean>(false)
  const [notificationfadeOut, setnotificationfadeOut] = useState(false)
  const notificationTimeOut: any = useRef()

  const handleNotification = (n: any): any => {
    // if (!n) {
    //   setnotificationfadeOut(true)
    //   clearTimeout(notificationTimeOut.current)
    //   setTimeout(() => {
    //     setnotification(n)
    //     setnotificationfadeOut(false)
    //   }, 333)
    // }
    if (!!n) {
      setnotification(n)
      clearTimeout(notificationTimeOut.current)
      notificationTimeOut.current = setTimeout(() => {
        setnotificationfadeOut(true)
        setTimeout(() => {
          setnotification(false)
          setnotificationfadeOut(false)
        }, 333)
      }, 1666)
    }
  }

  return [notification, handleNotification, notificationfadeOut]
}
